/** Display labels for the shared introductory event. This never changes its
 * hosts, availability, booking payload or notification configuration. */
export function getHueskotechBookingBrand({
  brand,
  teamSlug,
  eventSlug,
  isPlatform,
  locale,
}: {
  brand?: string | null;
  teamSlug?: string | null;
  eventSlug?: string | null;
  isPlatform?: boolean;
  locale?: string | null;
}) {
  if (
    brand !== "hueskotech" ||
    isPlatform ||
    teamSlug !== "venedy" ||
    eventSlug !== "venedy-partner-first-chat"
  ) {
    return undefined;
  }
  return {
    name: "Hueskotech",
    title: locale?.toLowerCase().startsWith("de") ? "Erstgespräch" : "Introductory meeting",
  };
}
